<template>
    <div class="table-wrapper">
        <CTable hover>
            <CTableHead>
                <CTableRow>
                    <CTableHeaderCell
                        scope="col"
                        v-for="col in tableCols"
                        :key="col.index"
                        >{{ $t(`${col.name}`) }}</CTableHeaderCell
                    >
                </CTableRow>
            </CTableHead>
            <CTableBody>
                <CTableRow v-for="(item, index) in tableData" :key="index + 1">
                    <CTableDataCell
                        >{{
                            Intl.DateTimeFormat('en-GB', dateOptions).format(
                                new Date(item.start),
                            )
                        }}
                        -
                        {{
                            Intl.DateTimeFormat('en-GB', dateOptions).format(
                                new Date(item.end),
                            )
                        }}</CTableDataCell
                    >
                    <CTableDataCell>{{
                        item.paid ? $t('general.yes') : $t('general.no')
                    }}</CTableDataCell>
                    <CTableDataCell>{{ item.user.user_name }}</CTableDataCell>
                    <CTableDataCell>{{
                        Intl.DateTimeFormat('en-GB', dateOptions).format(
                            new Date(item.date),
                        )
                    }}</CTableDataCell>
                    <CTableDataCell>{{ item.dayCount }}</CTableDataCell>
                    <CTableDataCell>{{
                        item.active === 'approved'
                            ? $t('vacation.approved')
                            : item.active === 'pending' ? $t('vacation.pending') : $t('vacation.notApproved')
                    }}</CTableDataCell>
                </CTableRow>
            </CTableBody>
        </CTable>
    </div>
</template>

<script>
import cols from '@/helpers/tableCols'
import options from '@/helpers/dateOptions'
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'VacationTable',
    setup() {
        const store = useStore()
        const state = reactive({
            dateOptions: options.dateOptions,
            tableCols: computed(() => cols.vacationCols),
            vacations: computed(() =>
                JSON.parse(
                    JSON.stringify(store.getters['hr/getVacationsCalendar']),
                ),
            ),
            currentUser: computed(
                () => store.getters['authorization/getCurrentUser'],
            ),
        })

        return { ...toRefs(state), store }
    },
    computed: {
        tableData() {
            return [...this.vacations]
                    .sort((a, b) => a.start - b.start)
                    .filter((item) => item.user.id !== this.currentUser.id)
                    .map((item) => {
                        let loop = new Date(item.start)
                        let count = 0

                        while (loop <= new Date(item.end)) {
                            if (loop.getDay() !== 0 && loop.getDay() !== 6)
                                count++
                            let newDate = loop.setDate(loop.getDate() + 1)
                            loop = new Date(newDate)
                        }

                        return {
                            id: item.id,
                            user: item.user,
                            start: item.start,
                            end: item.end,
                            date: item.date,
                            active: item.active,
                            without_pay: item.without_pay,
                            dayCount: count
                        }
                    })
        }
    },
    created() {
        this.$store
            .dispatch('hr/getVacationsCalendar')
            // .then(() => {
            //     let events = [...this.vacations]
            //         .sort((a, b) => a.start - b.start)
            //         .filter((item) => item.user.id !== this.currentUser.id)
            //         .map((item) => {
            //             let loop = new Date(item.start)
            //             let count = 0

            //             while (loop <= new Date(item.end)) {
            //                 if (loop.getDay() !== 0 && loop.getDay() !== 6)
            //                     count++
            //                 let newDate = loop.setDate(loop.getDate() + 1)
            //                 loop = new Date(newDate)
            //             }

            //             return {
            //                 id: item.id,
            //                 user: item.user,
            //                 start: item.start,
            //                 end: item.end,
            //                 date: item.date,
            //                 active: item.active,
            //                 without_pay: item.without_pay,
            //                 dayCount: count,
            //             }
            //         })
            //     console.log(events, 'events')
            //     console.log(this.currentUser, 'currentUser')
            // })
    }
}
</script>